import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LsAuthService } from 'src/app/core/services/auth-behavior/lsauth.service';
import { SettingsService } from 'src/app/core/settings';
import { NgIf } from '@angular/common';   

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: true,
  imports: [NgIf]
})
export class ErrorComponent {

  ErrorDescription: string;
  imageUrl = '';
  logoUrl = '';
  showDetails = false;

  constructor(private router: Router,  private LsAuthService: LsAuthService, private settings: SettingsService) { 
    this.logoUrl = this.settings.getSettings().cdnBaseUrl + '/Lightstone.Design/v1/images/logo.svg';
    this.imageUrl = this.settings.getSettings().cdnBaseUrl + '/Lightstone.Design/v1/images/bg-error.png';
    if(localStorage.getItem('ErrorDescription') != null)
      this.ErrorDescription = localStorage.getItem('ErrorDescription').split(":").join("<br>");
    else
      this.ErrorDescription = "An error occurred. Please try again later."; 
  }

  toggleDetails(){
    this.showDetails = !this.showDetails;
  }

  Logout(){
    this.LsAuthService.Logout();
  }

}
